import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from 'axios';
import { SERVER_URL } from "../../api/url";

const MenuItems = (props) => {
  const { parentMenu } = props;
  const location = useLocation();
  const [token, setToken] = useState("");
  const [categories, setCategories] = useState([]); 

  const [home, setHome] = useState(false);
  const [page, setPage] = useState(false);
  const [course, setCourse] = useState(false);
  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/about/view_category`);
      if (response.status === 200) {
        setCategories(response.data?.data || []);
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  useEffect(() => {
    const userToken = localStorage.getItem('userToken');
    setToken(userToken);
    fetchCategories(); 
  }, []);

  const openMobileMenu = (menu) => {
    if (menu === "home") {
      setHome(!home);
      setPage(false);
      setCourse(false);
    } else if (menu === "page") {
      setHome(false);
      setPage(!page);
      setCourse(false);
    } else if (menu === "course") {
      setHome(false);
      setPage(false);
      setCourse(!course);
    }
  };

  return (
    <>
      {/* Home Menu */}
      <li className={location.pathname === "/" ? "menu-active" : ""}>
        <Link to="/" onClick={() => openMobileMenu("home")}>Home</Link>
      </li>
      <li
        className={parentMenu === "about" ? "has-sub menu-active" : "has-sub"}
      >
        <Link
          to="#"
          className={page ? "hash menu-active" : "hash"}
          onClick={() => {
            openMobileMenu("page");
          }}
        >
          About
          <span className="arrow "></span>
        </Link>
        <ul className={page ? "sub-menu sub-menu-open" : "sub-menu"}>
          <li className={location.pathname === "/about" ? "menu-active" : ""}>
            <Link to="/about">About Us</Link>
          </li>
           <li
            className={location.pathname === "/instructor" ? "menu-active" : ""}
          >
            <Link to="/instructor">Meet Our Team</Link>
          </li>
          <li className={location.pathname === "/event" ? "menu-active" : ""}>
            <Link to="/event">Join Our Events & Programs</Link>
          </li>
         
        </ul>
      </li>



      {/* Courses Dynamic Menu */}
      <li className={parentMenu === "course" || course ? "has-sub menu-active" : "has-sub"}>
        <Link
          to="#"
          className={course ? "hash menu-active" : "hash"}
          onClick={() => openMobileMenu("course")}
        >
          Our Courses
          <span className="arrow"></span>
        </Link>
        <ul className={course ? "sub-menu sub-menu-open" : "sub-menu"}>
          {categories.map((cat) => (
            <li 
              key={cat._id} 
              className={location.pathname === `/${cat.name.replace(/\s+/g, '-')}` ? "menu-active" : ""}
            >
              <Link to={`/courses/${cat.name.replace(/\s+/g, '-')}`}>
                {cat.name}
              </Link>
            </li>
          ))}
        
          <li className={location.pathname === "/books" ? "menu-active" : ""}>
            <Link to="/books">French Book Store</Link>
          </li>
          <li className={location.pathname === "/level-test" ? "menu-active" : ""}>
            <Link to="/level-test">French Level Test</Link>
          </li>
        </ul>
      </li>

      {/* Blog & Contact */}
      <li className={location.pathname === "/blog" ? "menu-active" : ""}>
        <Link to="/blog">Blog</Link>
      </li>
      <li className={location.pathname === "/contact" ? "menu-active" : ""}>
        <Link to="/contact">Contact Us</Link>
      </li>

      <li className={location.pathname === "/quotation" ? "menu-active" : ""}>
        <Link to="/quotation">Quotation</Link>
      </li>
      {token ? (
        <li className={parentMenu === "profile" || page ? "has-sub menu-active" : "has-sub"}>
          <Link to="#" onClick={() => openMobileMenu("page")}>
            Profile <span className="arrow"></span>
          </Link>
          <ul className={page ? "sub-menu sub-menu-open" : "sub-menu"}>
            <li><Link to="/profile">My Profile</Link></li>
            <li>
              <Link to="/" onClick={() => {
                localStorage.clear();
                window.location.reload();
              }}>Logout</Link>
            </li>
          </ul>
        </li>
      ) : (
        <li className={location.pathname === "/login" ? "menu-active" : ""}>
          <Link to="/login">Login</Link>
        </li>
      )}
    </>
  );
};

export default MenuItems;